import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import Console from '@/views/console'
import Home from '@/views/Home'
import DetailsPage from '@/views/solution/DetailsPage'
import NodePage from '@/views/node/NodePage'
import PolicyList from '@/views/policy/PolicyList'
import SolutionList from '@/views/solution/SolutionList'
import IndustryList from '@/views/industry/IndustryList'
import PolicyDetails from '@/views/policy/PolicyDetails'
import IndustryDetails from '@/views/industry/IndustryDetails'
import MarketDetails from '@/views/market/MarketDetails'
import AppList from '@/views/market/AppList'
import Guidance from '@/views/node/Guidance'
import Operation from '@/views/node/Operation'
import SecondaryNode from '@/views/node/SecondaryNode'
import CompanyNode from '@/views/node/CompanyNode'
import Build from '@/views/node/Build'
import Discuss from '@/views/platform/Discuss'
import EnterpriseNode from '@/views/node/EnterpriseNode'
import DiscussDetails from '@/views/platform/DiscussDetails'
import ServiceDetails from '@/views/service/ServiceDetails'
import PersonalData from '@/views/console/PersonalData'
import MyDemand from '@/views/console/MyDemand'
import MyService from '@/views/console/MyService'
import MyJoin from '@/views/console/MyJoin'
import ApiDetail from '@/views/console/ApiDetail'
import OpenList from '@/views/Service/OpenList'
import SolvePlan from '@/views/console/SolvePlan'
import IOT from '@/views/console/IOT'
import MyApp from '@/views/console/MyApp'
import MyApply from '@/views/console/MyApply'
import AppMarket from '@/views/console/AppMarket'
import ServiceAdv from '@/views/console/ServiceAdv'
import ServiceMarket from '@/views/console/ServiceMarket'
import UpperNode from '@/views/node/UpperNode'
Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
}
export default new Router({
  mode: 'history', // hash模式注释掉
  scrollBehavior () {
      return { x: 0, y: 0 }
    },
  // base: './',
  routes: [
    {
      path: '/',
      redirect: "/home"
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/bind',
      name: 'bind',
      component: (resolve) => require(['@/views/bind'], resolve),
    },
    {
      path: '/platlogin',
      name: 'login',
      component: Login
    },
    {
      path: '/DetailsPage',
      name: 'DetailsPage',
      component: DetailsPage
    },
    {
      path: '/NodePage',
      name: 'NodePage',
      component: NodePage
    },
    {
      path: '/PolicyList',
      name: 'PolicyList',
      component: PolicyList
    },
    {
      path: '/SolutionList',
      name: 'SolutionList',
      component: SolutionList
    },
    {
      path: '/IndustryList',
      name: 'IndustryList',
      component: IndustryList
    },
    {
      path: '/PolicyDetails',
      name: 'PolicyDetails',
      component: PolicyDetails
    },
    {
      path: '/IndustryDetails',
      name: 'IndustryDetails',
      component: IndustryDetails
    },
    {
      path: '/marketdetails',
      name: 'marketdetails',
      component: MarketDetails
    },
    {
      path: '/appList',
      name: 'AppList',
      component: AppList
    },
    {
      path: '/UpperNode',
      name: 'UpperNode',
      component: UpperNode
    },
    {
      path: '/Guidance',
      name: 'Guidance',
      component: Guidance
    },
    {
      path: '/SecondaryNode',
      name: 'SecondaryNode',
      component: SecondaryNode
    },
    {
      path: '/CompanyNode',
      name: 'CompanyNode',
      component: CompanyNode
    },
    {
      path: '/operation',
      name: 'Operation',
      component: Operation
    },
    {
      path: '/build',
      name: 'Build',
      component: Build
    },
    {
      path: '/discuss',
      name: 'Discuss',
      component: Discuss
    },
    {
      path: '/EnterpriseNode',
      name: 'EnterpriseNode',
      component: EnterpriseNode
    },
    {
      path: '/DiscussDetails',
      name: 'DiscussDetails',
      component: DiscussDetails
    },
    {
      path: '/ServiceDetails',
      name: 'ServiceDetails',
      component: ServiceDetails
    },
    {
      path: '/openList',
      name: 'OpenList',
      component: OpenList
    },
    {
      path: '/console',
      name: 'console',
      component: Console,
      children: [
        {
          path: '/PersonalData',
          name: 'PersonalData',
          component: PersonalData
        },
        {
          path: '/MyDemand',
          name: 'MyDemand',
          component: MyDemand,
        },
        {
          path: '/MyService',
          name: 'MyService',
          component: MyService,
        },
        {
          path: '/MyJoin',
          name: 'MyJoin',
          component: MyJoin
        },
        {
          path: '/MyApp',
          name: 'MyApp',
          component: MyApp
        },
        {
          path: '/MyApply',
          name: 'MyApply',
          component: MyApply
        },
        {
          path: '/AppMarket',
          name: 'AppMarket',
          component: AppMarket
        },
        {
          path: '/SolvePlan',
          name: 'SolvePlan',
          component: SolvePlan
        },
        {
          path: '/ServiceAdv',
          name: 'ServiceAdv',
          component: ServiceAdv
        },
        {
          path: '/ServiceMarket',
          name: 'ServiceMarket',
          component: ServiceMarket
        },
        {
          path: '/ApiDetail',
          name: 'ApiDetail',
          component: ApiDetail
        },
        {
          path: '/IOT',
          name: 'IOT',
          component: IOT
        },

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js